import { cookies } from 'static';
import { fetchAuthAccountInfoForWorkingFarm } from './auth';

export const checkCrops = () => {
  const token = localStorage.getItem(cookies.FarmersPlanToken) !== null
    ? JSON.parse(localStorage?.getItem(cookies.FarmersPlanToken) || '')?.token
    : null;

  return fetchAuthAccountInfoForWorkingFarm(token);
};
